import { HUB } from 'constants/hubs';
import { Routes } from 'constants/routeConstants';

export const getVerificationRouteByHub = (hub) => {
  switch (hub) {
    case HUB.FUSION_MARKETS:
      return Routes.MY_ACCOUNTS;
    case HUB.FUSION_MARKETS_EU:
      return Routes.PROFILE_VERIFICATION;
    case HUB.FUSION_MARKETS_X:
      return Routes.PROFILE_VERIFICATION;
    default:
      return Routes.PROFILE_VERIFICATION;
  }
};
